import { useContext } from 'react';

import { ProductionCalendarContext } from './productionCalendarContext';

export const useProductionCalendarContext = () => {
  const context = useContext(ProductionCalendarContext);
  if (!context) {
    throw new Error(
      'useProductionCalendarContext must be used within a ProductionCalendarProvider'
    );
  }
  return context;
};
